import { render, staticRenderFns } from "./AttendeeFieldsContainer.vue?vue&type=template&id=39a174a0"
import script from "./AttendeeFieldsContainer.vue?vue&type=script&lang=js"
export * from "./AttendeeFieldsContainer.vue?vue&type=script&lang=js"
import style0 from "./AttendeeFieldsContainer.vue?vue&type=style&index=0&id=39a174a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports